<template>
  <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
    <div id="TituloDetalleDeDocumento_div">
      <h5 class="label-black" style="margin-bottom: 0px;">SEDES DEL ARCHIVO JUDICIAL</h5>
      <h6 class="label-black" style="margin-top: 0px;">Administración de las Sedes de Resguardo del Archivo Judicial</h6>
    </div>

    <div class="row d-flex">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
            <div class="area custom-area">
                <h6 class="label-black">Sedes de la Dirección del Archivo Judicial</h6>
                <div id="Sedes_table" class="table-responsive">
                    <table class="table table-striped table-light table-hover table-sm">
                    <thead class="thead-custom">
                        <tr>
                        <th>Nombre</th>
                        <th>Estado</th>
                        <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody class="text-dark">
                        <tr v-if="SedesArchivo.length <= 0">
                        <td colspan="12" class="text-center">No hay registro Partes</td>
                        </tr>
                        <tr v-else v-for="sedes in SedesArchivo" :key="sedes.SedeArchivoId">
                        
                        <td>{{sedes.Nombre}}</td>
                        <td v-if="sedes.Activo">Activo</td>
                        <td v-else>Inactivo</td>
                        <td>
                            <a v-on:click="EditarSede(sedes.SedeArchivoId)" title="Editar Sede">
                                <i class="fas fa-pen-square"></i>
                            </a>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div class="text-right">
                  <button class="btn btn-custom btn-sm" @click='NuevaSede()'>Agregar nueva Sede</button>
                </div>
           
                <h6 class="label-black">Asignación de Usuarios de las Sedes del Archivo Judicial</h6>
                <div id="Usuarios_table" class="table-responsive">
                    <table class="table table-striped table-light table-hover table-sm">
                    <thead class="thead-custom">
                        <tr>
                        <th>Usuario</th>
                        <th>Sede</th>
                        <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody class="text-dark">
                        <tr v-if="UsuariosSedes.length <= 0">
                        <td colspan="12" class="text-center">No hay registro de Usuarios</td>
                        </tr>
                        <tr v-else v-for="ListadoUsuario in UsuariosSedes" :key="ListadoUsuario.AsignacionSedeId">
                        
                        <td>{{ListadoUsuario.Usuario.Nombre}} {{ListadoUsuario.Usuario.ApellidoPaterno}} {{ListadoUsuario.Usuario.ApellidoMaterno}}</td>
                        <td>{{ListadoUsuario.Sede.Nombre}}</td>
                        <td>
                            <a v-on:click="NuevaAsignacion(ListadoUsuario)" title="Editar Usuario">
                                <i class="fas fa-pen-square"></i>
                            </a>
                            <a v-on:click="EliminarUsuario(ListadoUsuario)" title="Eliminar Usuario">
                                <i class="fas fa-minus-circle"></i>
                            </a>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div class="text-right">
                  <button class="btn btn-custom btn-sm" @click='NuevaAsignacion()'>Agregar Asignación</button>
                </div>
            </div>
        </div>
        <div v-if="this.ModalSedes == true">
            <Sedes :sede= this.parametro_SedeArchivo @dialogo='EstatusModal($event)'></Sedes>
        </div>
        <div v-if="this.ModalAsignacion == true">
            <Asignacion :usuarios= this.UsuariosSedes :asignacionSede= this.Asignacion @dialogo='AsignacionModal($event)'></Asignacion>
        </div>
    </div>
  </div>
</template>

<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import editSede from '@/components/ArchivoJudicial/Comun/AddEditSede.vue'
import EditAsignacion from '@/components/ArchivoJudicial/Comun/AddEditAsignacion.vue'
export default {
    components :{
        Sedes : editSede,
        Asignacion: EditAsignacion
    },
    data(){
        return{
            SedesArchivo: [],
            ModalSedes: false,
            ModalAsignacion:false,
            parametro_SedeArchivo: 0,
            UsuariosSedes:[],
            Asignacion: Object,
            UsuarioSeleccionado:{
                IdUsuario:0,
                Nombre:"",
                ApellidoPaterno:"",
                ApellidoMaterno: ""
            }
        }
    },
    methods:{
        ObtenerLista(){
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.ListaSedesArchivo, null,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
                if (respuesta.data.SiHayError){
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    comun.SeEstaCargandoInformacion(false);
                }
                else
                {
                    this.SedesArchivo = respuesta.data.GetListaSedesArchivo;
                    this.UsuariosSedes= respuesta.data.GetListaUsuarios;
                    comun.SeEstaCargandoInformacion(false);
                }
                comun.SeEstaCargandoInformacion(false);
                
            })
            .catch(e=> {
                console.log("No Hay Respuesta del Servidor", e);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });
        },
        EditarSede(id){
            this.parametro_SedeArchivo = id;
            this.ModalSedes = true;
        },
        NuevaSede(){
            this.parametro_SedeArchivo = 0;
            this.ModalSedes = true;
        },
        NuevaAsignacion(Objeto){
            this.Asignacion= Objeto;
            this.ModalAsignacion = true;
        },
        EstatusModal(valor){
            this.ModalSedes = valor;
            if(this.ModalSedes == false)
            {
                this.ObtenerLista();
            }
        },
        AsignacionModal(valor){
            this.ModalAsignacion = valor;
            if(this.ModalAsignacion == false)
            {
                this.ObtenerLista();
            }
        },
        EliminarUsuario(dato) {
            let peticion = {"AsignacionSedeId": dato.AsignacionSedeId}
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.EliminarUsuario, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
                if (respuesta.data.SiHayError){
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    comun.SeEstaCargandoInformacion(false);
                }
                else
                {
                    comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    comun.SeEstaCargandoInformacion(false);
                    this.ObtenerLista();
                }
                comun.SeEstaCargandoInformacion(false);
            })
            .catch(e=> {
                console.log("No Hay Respuesta del Servidor", e);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });
        }
    },
    mounted () {
        this.ObtenerLista();
    }
}
</script>

<style scoped>
    .thead-custom {
        background-color: #004746;
        color: white;
    }
    .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }

</style>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Inventario/SedesArchivo.vue